import { useEffect, useRef, useState } from "react";

/**
 * Tracks a synced flag and reports whether changes are pending or were
 * accepted while mounted (a false -> true transition, e.g. from a websocket
 * status update). Pass enabled=false until real data has loaded so the
 * initial placeholder -> loaded flip is not mistaken for an accepted change.
 */
export function usePendingChanges(synced: boolean, enabled: boolean = true) {
  const prevSynced = useRef<boolean | undefined>(undefined);
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (!enabled) {
      prevSynced.current = undefined;
      setAccepted(false);
      return;
    }
    if (prevSynced.current === false && synced) {
      setAccepted(true);
    } else if (!synced) {
      setAccepted(false);
    }
    prevSynced.current = synced;
  }, [synced, enabled]);

  return {
    pending: enabled && !synced,
    accepted: enabled && synced && accepted
  };
}
